import IconSvg from './svg.vue'
import Vue from 'vue'

const install = (Vue: any) => {
	Vue.component('IconFont', IconSvg)
}
export default install
